import { Permission } from '@shared/infrastructure/auth/permission.js';
import type { AppModule } from '@shared/presentation/router/composition.js';

/**
 * `users` module: who is allowed in and what each of them can do.
 *
 * It renders inside the shell, hence `layoutRoutes`. With no `meta.public`, the
 * guard protects it — which is the default behavior.
 *
 * The screen asks for `users:read` because that is what the listing it opens on
 * needs. The Grupos tab needs `groups:read` and checks for itself: gating the
 * whole route on it would lock out someone who only manages users.
 */
export const usersModule: AppModule = {
  name: 'users',
  routes: [],
  layoutRoutes: [
    {
      path: 'users',
      name: 'users',
      component: () => import('./presentation/UsersView.vue'),
      meta: { permission: Permission.USERS_READ },
    },
  ],
};
